export const INNER_GRID_X_PADDING = 20
export const INNER_GRID_WIDTH = 1200
export const BP_TABLET_7 = 600
export const BP_DESKTOP = 896
export const IS_PROD = process.env.NODE_ENV === 'production'



// WEBPACK FOOTER //
// ./resources/js/app/constants.js